const { REACT_APP_DEPLOY_PHASE } = process.env
export const CRUX_PHASE =
  REACT_APP_DEPLOY_PHASE === 'production' || REACT_APP_DEPLOY_PHASE === 'cbt'
    ? REACT_APP_DEPLOY_PHASE
    : 'sandbox'
export const AD_PLATFORM_TYPE = 'KEYWORDAD'
